export const POLICIES = [
	{
		id: 'INCOME_TAX_CHANGES',
		shorthand: 'it',
		name: 'Income Tax Rate Cuts and Bracket Changes',
		abbr: 'Income Tax Rate Cuts and Bracket Changes',
	},
	{
		id: 'STANDARD_DEDUCTION_EXPANSION',
		shorthand: 'sd',
		name: 'Standard Deduction Expansion',
		abbr: 'Standard Deduction Expansion',
	},
	{
		id: 'PERSONAL_EXEMPTION_REPEAL',
		shorthand: 'pe',
		name: 'Personal Exemption Repeal',
		abbr: 'Personal Exemption Repeal',
	},
	{
		id: 'CTC_EXPANSION',
		shorthand: 'ctc',
		name: 'Child Tax Credit Expansion',
		abbr: 'CTC Expansion',
	},
	{
		id: 'SALT_CAP',
		shorthand: 'salt',
		name: 'SALT Cap Changes',
		abbr: 'SALT Cap Changes',
	},
	{
		id: 'HMID_LIMIT',
		shorthand: 'hmid',
		name: 'Home Mortgage Interest Deduction limit',
		abbr: 'Home Mortgage Interest Deduction limit',
	},
	{
		id: 'ITEMIZED_DEDUCTION_LIMITS',
		shorthand: 'idl',
		name: 'Itemized Deduction limits',
		abbr: 'Itemized Deduction limits',
	},
	{
		id: 'AMT_CHANGES',
		shorthand: 'amt',
		name: 'Alternative Minimum Tax changes',
		abbr: 'Alternative Minimum Tax changes',
	},
	{
		id: 'PEASE_LIMITATION_SUSPENSION',
		shorthand: 'pl',
		name: 'Pease Limitation suspension',
		abbr: 'Pease Limitation suspension',
	},
	{
		id: 'SENIOR_DEDUCTION',
		shorthand: 'snd',
		name: 'Senior Deduction',
		abbr: 'Senior Deduction',
	},
	{
		id: '162M_LIMIT',
		shorthand: '162m',
		name: '162(M) Limitation',
		abbr: '162(M) Limitation',
	},
	{
		id: 'IND_CHAR_DED_CHANGE',
		shorthand: 'icd',
		name: 'Individual Charitable Deduction Changes',
		abbr: 'Individual Charitable Deduction Changes',
	},
	{
		id: 'AUTO_LOAN_DEDUCTION',
		shorthand: 'ald',
		name: 'Auto Loan Deduction',
		abbr: 'Auto Loan Deduction',
	},
	{
		id: 'IRA_CRED_REPEAL',
		shorthand: 'irc',
		name: 'Consumer IRA Credit Repeal',
		abbr: 'Consumer IRA Credit Repeal',
	},
	{
		id: 'PREMIUM_TAX_CREDIT_CHANGE',
		shorthand: 'ptc',
		name: 'Premium Tax Credit Changes',
		abbr: 'Premium Tax Credit Changes',
	},
	{
		id: 'TIP_DEDUCTION',
		shorthand: 'tip',
		name: 'Tip Deduction',
		abbr: 'Tip Deduction',
	},
	{
		id: 'OVERTIME_DEDUCTION',
		shorthand: 'ot',
		name: 'Overtime Deduction',
		abbr: 'Overtime Deduction',
	},
	{
		id: 'BUSINESS_PROVISIONS',
		shorthand: 'bp',
		name: 'Business Provisions',
		abbr: 'Business Provisions',
	},
	{
		id: 'INTERNATIONAL_BUSINESS_PROVISIONS',
		shorthand: 'ibp',
		name: 'International Provisions',
		abbr: 'International Provisions',
	},
] as const satisfies {
	id: string;
	shorthand: string;
	name: string;
	abbr: string;
}[];
